import { EnvConfig } from './feature-flag-service';

export type FeatureFlagKey =
  | 'YAWEB-3775-couponbox-migration'
  | 'YAWEB-2537-domestic-place' // (국내숙소) 필터 경험 개선
  | 'YAWEB-4001-remove-required-privacy' // [회원] 개인정보 필수 동의 제거
  | 'YAWEB-4307-plp-srp-text' // 국내숙소, 레저, 해외숙소 PLP/SRP 문구 수정
  | 'YAWEB-4958-user-integration' // 회원 통합
  | 'YAWEB-5584-nolHome' // NOL Home 개선
  | 'YAWEB-5731-nol-live-bridge' // NOL 라이브 브릿지 수정
  | 'YAWEB-6169-nol-ticket' // NOL 티켓 Faceoff
  | 'YAWEB-6561--plcc-new-pass-auth' // PLCC 신규 본인인증 SDK 적용
  | 'YAWEB-8411-member-class-vip-badge' // 회원 등급제 VIP 뱃지 (display-site의 원격 플래그 memberClassVipBadge와 동일 기능)
  | 'YAWEB-8384-train-reward-point' // 기차 선택한 승차권 구매 적립 NOL 포인트 안내
  | 'nolCoinMigration'; // NOL 코인 페이지 member-site 이관

type FeatureFlags = Record<FeatureFlagKey, EnvConfig>;

export const featureFlagsConfig: FeatureFlags = {
  'YAWEB-6561--plcc-new-pass-auth': {
    local: true,
    development: true,
    qa: true,
    stage: true,
    production: true,
  },
  'YAWEB-3775-couponbox-migration': {
    local: true,
    development: true,
    qa: true,
    stage: true,
    production: true,
  },
  'YAWEB-2537-domestic-place': {
    local: true,
    development: true,
    qa: true,
    stage: true,
    production: true,
  },
  'YAWEB-4001-remove-required-privacy': {
    local: true,
    development: true,
    qa: true,
    stage: true,
    production: true,
  },
  'YAWEB-4307-plp-srp-text': {
    local: true,
    development: true,
    qa: true,
    stage: true,
    production: true,
  },
  'YAWEB-4958-user-integration': {
    local: true,
    development: true,
    qa: true,
    stage: true,
    production: false,
  },
  'YAWEB-5584-nolHome': {
    local: true,
    development: true,
    qa: true,
    stage: true,
    production: true,
  },
  'YAWEB-5731-nol-live-bridge': {
    local: true,
    development: true,
    qa: true,
    stage: true,
    production: true,
  },
  'YAWEB-6169-nol-ticket': {
    local: true,
    development: true,
    qa: true,
    stage: true,
    production: true,
  },
  // stage/production은 display-site의 memberClassVipBadge와 노출 시점을 맞추기 위해 아직 닫아둔다.
  'YAWEB-8411-member-class-vip-badge': {
    local: true,
    development: true,
    qa: true,
    stage: true,
    production: false,
  },
  // stage/production은 플랫폼 적립 정책 오픈 시점에 맞춰 열어야 하므로 아직 닫아둔다.
  'YAWEB-8384-train-reward-point': {
    local: true,
    development: true,
    qa: true,
    stage: true,
    production: false,
  },
  nolCoinMigration: {
    local: true,
    development: true,
    qa: true,
    stage: true,
    production: true,
  },
};
